import React from 'react';

class Toolbar extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    };
    handleChange(e) {
        const files = e.target.files;
        if(files && files[0]) this.props.handleFile(files[0]);
    };
    render() { return (
        <div className="kate-toolbar">
            {this.props.children}
        </div>
    ); };
}

export default Toolbar;


// WEBPACK FOOTER //
// ./src/components/reusables/Toolbar.js